// Notes
export const GET_NOTES = "GET_NOTES";
export const GET_NOTE = "GET_NOTES";
export const NEW_NOTE = "NEW_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const RESET_NOTES = "RESET_NOTES";

// Authentication
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const AUTH_ERROR = "AUTH_ERROR";
export const IS_LOGGED = "IS_LOGGED";
export const UPDATE_SESSION_ID = "UPDATE_SESSION_ID";
export const SESSION_MISMATCH = "SESSION_MISMATCH";
export const VIEW_USER_REPORTS = "VIEW_USER_REPORTS";

// Notifications
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const NOTIFICATION_SHOWN = "NOTIFICATION_SHOWN";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";

// Spinner
export const SHOW_SPINNER = "SHOW_SPINNER";
export const HIDE_SPINNER = "HIDE_SPINNER";

// Courses
export const GET_COURSES = "GET_COURSES";
export const RESET_COURSES = "RESET_COURSES";
export const COURSES_LOADED = "COURSES_LOADED";

// Course
export const SET_CURRENT_COURSE = "SET_CURRENT_COURSE";
export const GET_COURSE_SECTIONS = "GET_COURSE_SECTIONS";
export const GET_COURSE_SECTION = "GET_COURSE_SECTION";
export const RESET_COURSE_SECTIONS = "RESET_COURSE_SECTIONS";
export const REFRESH_COURSE_SECTIONS = "REFRESH_COURSE_SECTIONS";
export const SET_COURSE_PERCENT = "SET_COURSE_PERCENT";

// Files - get files for current course
export const GET_FILE_LIST = "GET_FILE_LIST";
export const RESET_FILES = "RESET_FILES";

// Config
export const LOAD_CONFIG = "LOAD_CONFIG";
export const SAVE_CONFIG = "SAVE_CONFIG";
export const SAVE_MAIN_CONFIG = "SAVE_MAIN_CONFIG";
export const SAVE_PLAYER_CONFIG = "SAVE_PLAYER_CONFIG";
export const RESET_CONFIG = "RESET_CONFIG";

// Modals
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

// Exercise types
export const HISTORY = "HISTORY";
export const DRAMA = "DRAMA";
export const CONCERT = "CONCERT";
export const WORDS = "WORDS";
export const HOT_POINTS = "HOT_POINTS";
export const WORD_GAME = "WORD_GAME";
export const DIALOGUES = "DIALOGUES";
export const HOW_LANG_WORKS = "HOW_LANG_WORKS";
export const SAY = "SAY";
export const GRAMMAR = "GRAMMAR";
export const FILE = "FILE";
export const GET_EXERCISE = "GET_EXERCISE";
export const RESET_EXERCISES = "RESET_EXERCISES";
export const EVALUATION = "EVALUATION";
export const DIY = "DIY";
export const THE_WORDS = "THE_WORDS";
export const JEOPARDY = "JEOPARDY";

// Game types

export const MOST_USEFUL = "MOST_USEFUL";
export const LEARN_BY_HEART = "LEARN_BY_HEART";
export const MATCH_IT = "MATCH_IT";
export const ORDER_THEM = "ORDER_THEM";
export const WORD_NETWORK = "WORD_NETWORK";
export const OPPOSITES = "OPPOSITES";
export const TALK_TO_ME = "TALK_TO_ME";
export const AT_HOME = "AT_HOME";
export const READ_UNDERSTAND = "READ_UNDERSTAND";
export const CARDS = "CARDS";
export const LISTEN_UNDERSTAND = "LISTEN_UNDERSTAND";
export const PLAY_IT = "PLAY_IT";
export const PAIRS = "PAIRS";
export const VISUALIZE = "VISUALIZE";
export const QUIZ = "QUIZ";
export const CURIOSITIES = "CURIOSITIES";
export const THE_OTHER = "THE_OTHER";

// Message variants
export const ADD_MESSAGE = "ADD_MESSAGE";
export const CLOSE_MESSAGE = "CLOSE_MESSAGE";
export const SUCCESS = "SUCCESS";
export const WARNING = "WARNING";
export const INFO = "INFO";
export const ERROR = "ERROR";
export const BANNER = "BANNER";
export const RESET_MESSAGES = "RESET_MESSAGES";

// Audio
export const AUDIO_VOL = "AUDIO_VOL";
export const SOUND_VOL = "SOUND_VOL";

// User State
export const GET_USER_STATE = "GET_USER_STATE";
export const SAVE_USER_STATE = "SAVE_USER_STATE";
export const SAVE_BOOKMARKS = "SAVE_BOOKMARKS";
export const ADD_BOOKMARK = "ADD_BOOKMARK";
export const DELETE_BOOKMARK = "DELETE_BOOKMARK";
export const SET_CURRENT_EXERCISE = "SET_CURRENT_EXERCISE";
export const ADD_RECENT_NOTE = "ADD_RECENT_NOTE";
export const DELETE_RECENT_NOTE = "DELETE_RECENT_NOTE";
export const RESET_USER_STATE = "RESET_USER_STATE";
export const SET_CURRENT_COURSE_ID = "SET_CURRENT_COURSE_ID";
export const SET_CURRENT_SECTION_ID = "SET_CURRENT_SECTION_ID";

// Stats
export const START_STAT_TIME = "START_STAT_TIME";
export const STOP_STAT_TIMER = "STOP_STAT_TIME";
export const STAT_CURRENT_EXERCISE = "STAT_CURRENT_EXERCISE";
export const MARK_COMPLETE = "MARK_COMPLETE";
export const GET_WEEKLY_TIME = "GET_WEEKLY_TIME";
export const GET_DAILY_TIME = "GET_DAILY_TIME";
export const GET_STATS = "GET_STATS";
export const GET_BSTATS = "GET_BSTATS"; // Backend stats

// Tools
export const TOOLS_DATA = "TOOLS_DATA";

// XML
export const GET_XML = "GET_XML";

// Dialogs
export const SETTINGS_DIALOG = "SETTINGS_DIALOG";
export const TEST_DIALOG = "TEST_DIALOG";

// Keyboard handling
export const ADD_KEYBOARD_EVENTS = "ADD_KEYBOARD_EVENTS";
export const DEL_KEYBOARD_EVENTS = "DEL_KEYBOARD_EVENTS";
